<div id="cover" *ngIf="projectService.loading()"></div>

<div *ngIf="loading" class="row no-data page-center">
    <img src="../../assets/img/no-data.png">
</div>

<div class="col-md-12 text-end mb-2">
    <button name="add" type="button" class="btn-primary-save" (click)="addUser()">
        <i class="fa fa-plus" title="Add"></i> User Creation
    </button>
</div>
<div class="section-page dashboard">
    <div class="container-fluid">
        <ag-grid-angular class="ag-theme-alpine" *ngIf="userCreationList.length" [rowData]="userCreationList"
            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"  
            (firstDataRendered)="onFirstDataRendered($event)" [pagination]="true" style="height: 100%; width: auto;">
        </ag-grid-angular>
    </div>
</div>

<p-dialog header="User Details" [(visible)]="commonDataObject.displayDialog" [modal]="true" [closable]="true"
    (onHide)="cancel()"[style]="{width: '900px'}">
    <form [formGroup]="userForm" autocomplete="off">
        <div class="row">
            <div class="col-md-4">
                <label class="col-form-label">First Name <span style="color: red;">*</span></label>
                <input type="text" pInputText name="first_name" formControlName="first_name" />
            </div>
            <div class="col-md-4">
                <label class="col-form-label">Last Name <span style="color: red;">*</span></label>
                <input type="text" pInputText name="last_name" formControlName="last_name" />
            </div>

            <div class="col-md-4">
                <label class="col-form-label">Email <span style="color: red;">*</span></label>
                <input type="email" pInputText pattern="[^@\s]+@[^@\s]+\.[^@\s]+" name="email_address"
                    formControlName="email_address" autocomplete="new-email" />
            </div>

            <div *ngIf="!userForm?.get('user_code')?.value" class="col-md-4">
                <label class="col-form-label">Password <span style="color: red;">*</span></label>
                <input type="password" pInputText name="password" formControlName="password"
                    autocomplete="new-password" />
            </div>

            <div class="col-md-4">
                <label class="col-form-label">Contact Number <span style="color: red;">*</span></label>
                <input type="text" pInputText name="contact_number" maxlength="10" formControlName="contact_number" />
            </div>
            <div class="col-md-4">
                <label class="col-form-label">Project <font color="red">*</font></label>
                <p-multiSelect [style]="{'width':'100%'}" [resetFilterOnHide]="true" id="project" appendTo="body"
                    [options]="projectService.getProjectMaster()" placeholder="None Selected" optionLabel="project_name"
                    formControlName="project">
                </p-multiSelect>
            </div>
            <div class="col-md-4">
                <label class="col-form-label">User Category <font color="red">*</font></label>
                <p-select class="small-form-control" [style]="{'width':'100%'}" [resetFilterOnHide]="true"
                    id="user_category" appendTo="body" [options]="userCategory"
                    placeholder="None Selected" optionLabel="user_category_name" formControlName="user_category">
                </p-select>
            </div>
            <div class="col-md-4">
                <label class="col-form-label">Status</label>
                <p-toggleSwitch id="is_active" formControlName="is_active"></p-toggleSwitch>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button type="button" class="btn-cancel-secondary" label="Show" (click)="cancel()">
            <i class="fa fa-close"></i> Close
        </button>
        <button type="button" appBtnDisableOnApiCall class="btn-primary-save" label="Show" [disabled]="userForm.invalid"
            (click)="saveUserData()">
            <i class="fa fa-save"></i> Save
        </button>
    </ng-template>
</p-dialog>

<p-dialog header="Delete Project" [(visible)]="commonDataObject.deleteDialog" [modal]="true" [closable]="true"
    [style]="{width: '600px'}">
    <div class="row">
        <div class="col-md-12">
            Are you sure you want to delete this User?
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" class="btn-cancel-secondary" label="Show" (click)="commonDataObject.deleteDialog = false">
            No
        </button>
        <button type="button" class="btn-danger-delete" label="Show" (click)="saveUserData('Delete')">
            Yes
        </button>
    </ng-template>
</p-dialog>

<div class="alert-message" [class.show]="commonDataObject.issuccessAlert || commonDataObject.iserrorAlert"
    [class.success]="commonDataObject.issuccessAlert" [class.error]="commonDataObject.iserrorAlert">
    <i class="fas" [class.fa-check-circle]="commonDataObject.issuccessAlert"
        [class.fa-exclamation-circle]="commonDataObject.iserrorAlert"></i>
    <span>{{ commonDataObject.apiMeassge }}</span>
    <i class="fas fa-times close-alert"
        (click)="commonDataObject.issuccessAlert = false; commonDataObject.iserrorAlert = false"></i>
</div>